var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.57599 8.63871C1.32265 6.88071 1.19599 6.00137 1.55665 5.25004C1.91732 4.49871 2.68399 4.04137 4.21799 3.12804L5.14132 2.57804C6.53332 1.74804 7.23065 1.33337 7.99998 1.33337C8.76932 1.33337 9.46599 1.74804 10.8587 2.57804L11.782 3.12804C13.3153 4.04137 14.0827 4.49871 14.4433 5.25004C14.804 6.00137 14.6767 6.88071 14.4233 8.63871L14.238 9.93004C13.9133 12.1887 13.7507 13.3174 12.9673 13.992C12.184 14.6667 11.0353 14.6667 8.73732 14.6667H7.26265C4.96465 14.6667 3.81598 14.6667 3.03265 13.992C2.24932 13.3174 2.08665 12.1887 1.76198 9.93004L1.57599 8.63871Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H6",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome1);
export default __webpack_public_path__ + "static/media/home1.d1bd648d5ffa059f69f9410788898aef.svg";
export { ForwardRef as ReactComponent };